export default "<app-pplus-checkbox [(ngModel)]=\"allSelected\" (onChange)=\"toggleSelection($event)\"></app-pplus-checkbox>"